import type { NavigateFunction } from 'react-router-dom'

const PATIENT_PROFILE_PATH_PREFIX = '/patient-profile/'

export type PatientProfileLocationState = {
  returnTo?: string
}

export function buildPatientProfilePath(patientId: string): string {
  return `/patient-profile/${encodeURIComponent(patientId)}`
}

export type PatientProfilePreviousPage = {
  path: string
  backLabel: string
  profileTab?: string
}

export function buildPatientProfilePreviousPage(
  patientId: string,
  profileTab?: string,
): PatientProfilePreviousPage {
  return {
    path: buildPatientProfilePath(patientId),
    backLabel: 'Back to patient profile',
    ...(profileTab ? { profileTab } : {}),
  }
}

export function buildPatientProfileLocationState(
  returnTo: string,
): PatientProfileLocationState {
  return { returnTo }
}

export function mergePatientProfileLocationState(
  currentState: unknown,
  returnTo?: string,
): PatientProfileLocationState {
  const prior = (currentState as PatientProfileLocationState | null) ?? {}
  const nextReturnTo = returnTo ?? prior.returnTo
  return nextReturnTo ? { ...prior, returnTo: nextReturnTo } : prior
}

export function getPatientProfileReturnPath(
  state: unknown,
  fallback = '/',
): string {
  const { returnTo } = (state as PatientProfileLocationState | null) ?? {}
  if (
    typeof returnTo === 'string' &&
    returnTo.length > 0 &&
    !returnTo.startsWith(PATIENT_PROFILE_PATH_PREFIX)
  ) {
    return returnTo
  }
  return fallback
}

export function navigateToPatientProfile(
  navigate: NavigateFunction,
  patientId: string,
  returnTo: string,
): void {
  navigate(buildPatientProfilePath(patientId), {
    state: buildPatientProfileLocationState(returnTo),
  })
}

export function navigateToPatientProfilePreservingReturn(
  navigate: NavigateFunction,
  patientId: string,
  currentState: unknown,
): void {
  navigate(buildPatientProfilePath(patientId), {
    state: mergePatientProfileLocationState(currentState),
  })
}
